import { render, staticRenderFns } from "./Notaries.vue?vue&type=template&id=17858f96&"
import script from "./Notaries.vue?vue&type=script&lang=ts&"
export * from "./Notaries.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports